// @ts-nocheck
import Checkbox, { CheckboxProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import React, { FC, useEffect, useState } from "react";

const getCheckedBoolean = (value: CheckboxProps["checked"]) => value === true;

export interface CheckboxWithInputProps extends CheckboxProps {
    id: string;
    name?: string;
    value: string;
}

const CheckboxWithInput: FC<CheckboxWithInputProps> = ({
    checked,
    children,
    id,
    name,
    onChange,
    value,
    ...checkboxProps
}) => {
    const [isChecked, setIsChecked] = useState(getCheckedBoolean(checked));

    useEffect(() => {
        const checkedBoolean = getCheckedBoolean(checked);
        if (isChecked !== checkedBoolean) {
            setIsChecked(checkedBoolean);
        }
    }, [checked]);

    const onChangeWithInput = (event: React.SyntheticEvent, value: boolean) => {
        setIsChecked(value);
        onChange?.(event, value);
    };

    return (
        <Checkbox {...checkboxProps} checked={isChecked} onChange={onChangeWithInput}>
            <input type="hidden" disabled={!isChecked} id={id} name={name || id} value={value} />
            {children}
        </Checkbox>
    );
};

export default CheckboxWithInput;
